import * as React from 'react'
import { Label } from '~/@/components/ui/label'
import { Switch, SwitchProps } from '~/@/components/ui/switch-v2'
import { cn } from '~/@/lib/utils'

export type ToggleProps = SwitchProps & {
  label?: string
  className?: string
}

export const Toggle = React.forwardRef<React.ElementRef<typeof Switch>, ToggleProps>(
  ({ id, className, label, required, ...props }, ref) => {
    // Use React.useId for a stable, unique id per instance if not provided
    const autoId = React.useId()
    const toggleId = id || autoId

    return (
      <div className={cn('doss-toggle flex items-center p-1', className)}>
        <Switch id={toggleId} ref={ref} {...props} />
        {label && (
          <Label className={cn('ps-2 cursor-pointer text-sm py-1')} htmlFor={toggleId}>
            {label}
          </Label>
        )}
      </div>
    )
  },
)

Toggle.displayName = 'Toggle'
